import React, { useRef, useState } from 'react';
import pricing from '../../files/gebuehren_end_version_2022.pdf';
import emailjs from '@emailjs/browser';
import Popup from '../Popup';
import AnnourFooter from './AnnourFooter';

const StudentRegForm = () => {
  const [formData, setFormData] = useState({
    vorkenntnisse: false,
    leseniveau: '',
    muttersprache: '',
    woherkennen: '',
    nachname: '',
    vorname: '',
    vornameArabisch: '',
    nachnameArabisch: '',
    geburtsdatum: '',
    plz: '',
    telefon: '',
    email: '',
    text: '',
  });

  const form = useRef();

  const [msg, setMsg] = useState('');

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        'service_00kwshd',
        'template_ka9thgs',
        form.current,
        'DiyRY4XvPMpzgMZI2',
      )
      .then(
        (result) => {
          togglePopup();
          setMsg('Anfrage wurde erfolgreich verschickt');
          setFormData({
            vorkenntnisse: false,
            leseniveau: '',
            muttersprache: '',
            woherkennen: '',
            nachname: '',
            vorname: '',
            vornameArabisch: '',
            nachnameArabisch: '',
            geburtsdatum: '',
            plz: '',
            telefon: '',
            email: '',
            text: '',
          });
        },
        (error) => {
          togglePopup();
          setMsg('Fehlgeschlagen! :/');
        },
      );
    e.target.reset();
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Add your form submission logic here
    sendEmail(e);
  };

  const [selectedOption, setSelectedOption] = useState('');

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const options = [
    'Bitte auswählen',
    'Durch eine Suchmaschine',
    'Durch soziale Medien',
    'Durch Empfehlungen von Freunden',
    'Lieber nicht beantworten',
  ];

  const [popupIsOpen, setPopupIsOpen] = useState(false);

  const togglePopup = () => {
    if (popupIsOpen) {
      setMsg('');
    }
    setPopupIsOpen(!popupIsOpen);
  };

  return (
    <div className="min-h-screen pt-12 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-blue-50 to-white">
      <div className="max-w-4xl mx-auto">
        <Popup
          togglePopup={togglePopup}
          isOpen={popupIsOpen}
          msg={msg}
        />
        <div className="text-center mb-8">
          <h2 className="text-2xl font-bold text-gray-800 mb-4">
            Die monatlichen Unterrichtsgebühren der arabischen
            Unterrichte können Sie hier lesen
          </h2>
          <a
            className="inline-flex items-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors duration-300 text-xl font-bold"
            href={pricing}
            download={pricing}
          >
            <span>📄</span>
            Gebühren
          </a>
          <h2 className="text-xl mt-8 mb-6 text-gray-700">
            Sie können Ihr Kind bei uns mittels untenstehendem
            Formular für die arabischen Unterrichte auf die Warteliste
            anmelden lassen
          </h2>

          <div className="bg-white/90 backdrop-blur-sm rounded-xl shadow-lg border border-blue-100 p-6 mb-8">
            <h3 className="text-xl font-semibold text-cyan-900 mb-4">
              Unterrichtszeiten der Gruppen:
            </h3>
            <div className="grid md:grid-cols-3 gap-6">
              <div className="bg-blue-50 p-4 rounded-lg">
                <h4 className="font-bold text-lg text-blue-800 mb-2">
                  Gruppe 1
                </h4>
                <ul className="space-y-1 text-gray-700">
                  <li className="flex items-center gap-2">
                    <span className="text-blue-600">📅</span>{' '}
                    Samstags: 17:15 - 19:15
                  </li>
                  <li className="flex items-center gap-2">
                    <span className="text-blue-600">📅</span>{' '}
                    Mittwochs: 16:30 - 18:30
                  </li>
                </ul>
              </div>
              <div className="bg-blue-50 p-4 rounded-lg">
                <h4 className="font-bold text-lg text-blue-800 mb-2">
                  Gruppe 2
                </h4>
                <ul className="space-y-1 text-gray-700">
                  <li className="flex items-center gap-2">
                    <span className="text-blue-600">📅</span>{' '}
                    Samstags: 14:15 - 16:15
                  </li>
                  <li className="flex items-center gap-2">
                    <span className="text-blue-600">📅</span>{' '}
                    Mittwochs: 16:30 - 18:30
                  </li>
                </ul>
              </div>
              <div className="bg-blue-50 p-4 rounded-lg">
                <h4 className="font-bold text-lg text-blue-800 mb-2">
                  Gruppe 3
                </h4>
                <ul className="space-y-1 text-gray-700">
                  <li className="flex items-center gap-2">
                    <span className="text-blue-600">📅</span>{' '}
                    Freitags: 16:30 - 18:30
                  </li>
                  <li className="flex items-center gap-2">
                    <span className="text-blue-600">📅</span> Montags:
                    16:30 - 18:30
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <form
          ref={form}
          className="mx-auto p-8 bg-white/90 backdrop-blur-sm rounded-xl shadow-2xl border border-blue-100"
          onSubmit={handleSubmit}
        >
          <div className="mb-4 flex items-center">
            <label
              htmlFor="vorkenntnisse"
              className="flex items-center text-sm font-medium text-gray-700"
            >
              Sind Vorkenntnisse im Lesen der arabischen Sprache
              vorhanden:
            </label>

            <label className="ml-4 relative inline-flex items-center cursor-pointer">
              <input
                name="vorkenntnisse"
                type="checkbox"
                checked={formData.vorkenntnisse}
                onChange={handleChange}
                className="sr-only peer"
              />
              <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
            </label>
          </div>

          {formData.vorkenntnisse && (
            <div className="mb-4">
              <label className="block mb-2 text-sm font-medium text-gray-700">
                Welches Leseniveau hat das Kind?
              </label>

              <select
                name="leseniveau"
                value={formData.leseniveau}
                onChange={handleChange}
                required={formData.vorkenntnisse}
                className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:border-cyan-700"
              >
                <option value="">Bitte auswählen</option>
                <option value="Buchstaben">Buchstaben</option>
                <option value="Wörter">Wörter</option>
                <option value="Sätze">Sätze</option>
                <option value="Abschnitte">Abschnitte</option>
              </select>
            </div>
          )}

          {/*checkboxActiv && <p>lesen? hören? schreiben? sprechen?</p>*/}

          <div className="mb-4">
            <div className="relative h-10 w-full min-w-[200px]">
              <input
                name="nachname"
                onChange={handleChange}
                value={formData.nachname}
                className="peer h-full w-full rounded-[7px] border border-blue-gray-200 border-t-transparent bg-transparent px-3 py-2.5 font-sans text-sm font-normal text-blue-gray-700 outline outline-0 transition-all placeholder-shown:border placeholder-shown:border-blue-gray-200 placeholder-shown:border-t-blue-gray-200 focus:border-2 focus:border-cyan-700 focus:border-t-transparent focus:outline-0 disabled:border-0 disabled:bg-blue-gray-50"
                placeholder=" "
                required
              />
              <label className="before:content[' '] after:content[' '] pointer-events-none absolute left-0 -top-1.5 flex h-full w-full select-none text-[11px] font-normal leading-tight text-blue-gray-400 transition-all before:pointer-events-none before:mt-[6.5px] before:mr-1 before:box-border before:block before:h-1.5 before:w-2.5 before:rounded-tl-md before:border-t before:border-l before:border-blue-gray-200 before:transition-all after:pointer-events-none after:mt-[6.5px] after:ml-1 after:box-border after:block after:h-1.5 after:w-2.5 after:flex-grow after:rounded-tr-md after:border-t after:border-r after:border-blue-gray-200 after:transition-all peer-placeholder-shown:text-sm peer-placeholder-shown:leading-[3.75] peer-placeholder-shown:text-blue-gray-500 peer-placeholder-shown:before:border-transparent peer-placeholder-shown:after:border-transparent peer-focus:text-[11px] peer-focus:leading-tight peer-focus:text-cyan-900 peer-focus:before:border-t-2 peer-focus:before:border-l-2 peer-focus:before:border-cyan-900 peer-focus:after:border-t-2 peer-focus:after:border-r-2 peer-focus:after:border-cyan-900 peer-disabled:text-transparent peer-disabled:before:border-transparent peer-disabled:after:border-transparent peer-disabled:peer-placeholder-shown:text-blue-gray-500">
                *Nachname des Kindes
              </label>
            </div>
          </div>

          <div className="mb-4">
            <div className="relative h-10 w-full min-w-[200px]">
              <input
                name="vorname"
                onChange={handleChange}
                value={formData.vorname}
                className="peer h-full w-full rounded-[7px] border border-blue-gray-200 border-t-transparent bg-transparent px-3 py-2.5 font-sans text-sm font-normal text-blue-gray-700 outline outline-0 transition-all placeholder-shown:border placeholder-shown:border-blue-gray-200 placeholder-shown:border-t-blue-gray-200 focus:border-2 focus:border-cyan-700 focus:border-t-transparent focus:outline-0 disabled:border-0 disabled:bg-blue-gray-50"
                placeholder=" "
                required
              />
              <label className="before:content[' '] after:content[' '] pointer-events-none absolute left-0 -top-1.5 flex h-full w-full select-none text-[11px] font-normal leading-tight text-blue-gray-400 transition-all before:pointer-events-none before:mt-[6.5px] before:mr-1 before:box-border before:block before:h-1.5 before:w-2.5 before:rounded-tl-md before:border-t before:border-l before:border-blue-gray-200 before:transition-all after:pointer-events-none after:mt-[6.5px] after:ml-1 after:box-border after:block after:h-1.5 after:w-2.5 after:flex-grow after:rounded-tr-md after:border-t after:border-r after:border-blue-gray-200 after:transition-all peer-placeholder-shown:text-sm peer-placeholder-shown:leading-[3.75] peer-placeholder-shown:text-blue-gray-500 peer-placeholder-shown:before:border-transparent peer-placeholder-shown:after:border-transparent peer-focus:text-[11px] peer-focus:leading-tight peer-focus:text-cyan-900 peer-focus:before:border-t-2 peer-focus:before:border-l-2 peer-focus:before:border-cyan-900 peer-focus:after:border-t-2 peer-focus:after:border-r-2 peer-focus:after:border-cyan-900 peer-disabled:text-transparent peer-disabled:before:border-transparent peer-disabled:after:border-transparent peer-disabled:peer-placeholder-shown:text-blue-gray-500">
                *Vorname des Kindes
              </label>
            </div>
          </div>

          <div className="mb-4">
            <div className="relative h-10 w-full min-w-[200px]">
              <input
                name="vornameArabisch"
                onChange={handleChange}
                value={formData.vornameArabisch}
                className="peer h-full w-full rounded-[7px] border border-blue-gray-200 border-t-transparent bg-transparent px-3 py-2.5 font-sans text-sm font-normal text-blue-gray-700 outline outline-0 transition-all placeholder-shown:border placeholder-shown:border-blue-gray-200 placeholder-shown:border-t-blue-gray-200 focus:border-2 focus:border-cyan-700 focus:border-t-transparent focus:outline-0 disabled:border-0 disabled:bg-blue-gray-50"
                placeholder=" "
                dir="rtl"
              />
              <label className="before:content[' '] after:content[' '] pointer-events-none absolute left-0 -top-1.5 flex h-full w-full select-none text-[11px] font-normal leading-tight text-blue-gray-400 transition-all before:pointer-events-none before:mt-[6.5px] before:mr-1 before:box-border before:block before:h-1.5 before:w-2.5 before:rounded-tl-md before:border-t before:border-l before:border-blue-gray-200 before:transition-all after:pointer-events-none after:mt-[6.5px] after:ml-1 after:box-border after:block after:h-1.5 after:w-2.5 after:flex-grow after:rounded-tr-md after:border-t after:border-r after:border-blue-gray-200 after:transition-all peer-placeholder-shown:text-sm peer-placeholder-shown:leading-[3.75] peer-placeholder-shown:text-blue-gray-500 peer-placeholder-shown:before:border-transparent peer-placeholder-shown:after:border-transparent peer-focus:text-[11px] peer-focus:leading-tight peer-focus:text-cyan-900 peer-focus:before:border-t-2 peer-focus:before:border-l-2 peer-focus:before:border-cyan-900 peer-focus:after:border-t-2 peer-focus:after:border-r-2 peer-focus:after:border-cyan-900 peer-disabled:text-transparent peer-disabled:before:border-transparent peer-disabled:after:border-transparent peer-disabled:peer-placeholder-shown:text-blue-gray-500">
                Vorname des Kindes auf Arabisch
              </label>
            </div>
          </div>

          <div className="mb-4">
            <div className="relative h-10 w-full min-w-[200px]">
              <input
                name="nachnameArabisch"
                onChange={handleChange}
                value={formData.nachnameArabisch}
                className="peer h-full w-full rounded-[7px] border border-blue-gray-200 border-t-transparent bg-transparent px-3 py-2.5 font-sans text-sm font-normal text-blue-gray-700 outline outline-0 transition-all placeholder-shown:border placeholder-shown:border-blue-gray-200 placeholder-shown:border-t-blue-gray-200 focus:border-2 focus:border-cyan-700 focus:border-t-transparent focus:outline-0 disabled:border-0 disabled:bg-blue-gray-50"
                placeholder=" "
                dir="rtl"
              />
              <label className="before:content[' '] after:content[' '] pointer-events-none absolute left-0 -top-1.5 flex h-full w-full select-none text-[11px] font-normal leading-tight text-blue-gray-400 transition-all before:pointer-events-none before:mt-[6.5px] before:mr-1 before:box-border before:block before:h-1.5 before:w-2.5 before:rounded-tl-md before:border-t before:border-l before:border-blue-gray-200 before:transition-all after:pointer-events-none after:mt-[6.5px] after:ml-1 after:box-border after:block after:h-1.5 after:w-2.5 after:flex-grow after:rounded-tr-md after:border-t after:border-r after:border-blue-gray-200 after:transition-all peer-placeholder-shown:text-sm peer-placeholder-shown:leading-[3.75] peer-placeholder-shown:text-blue-gray-500 peer-placeholder-shown:before:border-transparent peer-placeholder-shown:after:border-transparent peer-focus:text-[11px] peer-focus:leading-tight peer-focus:text-cyan-900 peer-focus:before:border-t-2 peer-focus:before:border-l-2 peer-focus:before:border-cyan-900 peer-focus:after:border-t-2 peer-focus:after:border-r-2 peer-focus:after:border-cyan-900 peer-disabled:text-transparent peer-disabled:before:border-transparent peer-disabled:after:border-transparent peer-disabled:peer-placeholder-shown:text-blue-gray-500">
                Nachname des Kindes auf Arabisch
              </label>
            </div>
          </div>

          <div className="mb-4 relative h-10 w-full min-w-[200px]">
            <input
              type="date"
              name="geburtsdatum"
              value={formData.geburtsdatum}
              onChange={handleChange}
              className="peer h-full w-full rounded-[7px] border border-blue-gray-200 border-t-transparent bg-transparent px-3 py-2.5 font-sans text-sm font-normal text-blue-gray-700 outline outline-0 transition-all placeholder-shown:border placeholder-shown:border-blue-gray-200 placeholder-shown:border-t-blue-gray-200 focus:border-2 focus:border-cyan-700 focus:border-t-transparent focus:outline-0 disabled:border-0 disabled:bg-blue-gray-50"
              placeholder=" "
            />
            <label className="before:content[' '] after:content[' '] pointer-events-none absolute left-0 -top-1.5 flex h-full w-full select-none text-[11px] font-normal leading-tight text-blue-gray-400 transition-all before:pointer-events-none before:mt-[6.5px] before:mr-1 before:box-border before:block before:h-1.5 before:w-2.5 before:rounded-tl-md before:border-t before:border-l before:border-blue-gray-200 before:transition-all after:pointer-events-none after:mt-[6.5px] after:ml-1 after:box-border after:block after:h-1.5 after:w-2.5 after:flex-grow after:rounded-tr-md after:border-t after:border-r after:border-blue-gray-200 after:transition-all peer-placeholder-shown:text-sm peer-placeholder-shown:leading-[3.75] peer-placeholder-shown:text-blue-gray-500 peer-placeholder-shown:before:border-transparent peer-placeholder-shown:after:border-transparent peer-focus:text-[11px] peer-focus:leading-tight peer-focus:text-cyan-900 peer-focus:before:border-t-2 peer-focus:before:border-l-2 peer-focus:before:border-cyan-900 peer-focus:after:border-t-2 peer-focus:after:border-r-2 peer-focus:after:border-cyan-900 peer-disabled:text-transparent peer-disabled:before:border-transparent peer-disabled:after:border-transparent peer-disabled:peer-placeholder-shown:text-blue-gray-500">
              Geburtsdatum
            </label>
          </div>

          <div className="mb-4">
            <label className="block mb-2 text-sm font-medium text-gray-700">
              Welche Muttersprache hat das Kind?
            </label>

            <input
              name="muttersprache"
              value={formData.muttersprache}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:border-cyan-700"
              placeholder="z.B. Arabisch, Deutsch, Türkisch ..."
            />
          </div>

          <div className="mb-4 relative h-10 w-full min-w-[200px]">
            <input
              type="number"
              name="plz"
              value={formData.plz}
              onChange={handleChange}
              className="peer h-full w-full rounded-[7px] border border-blue-gray-200 border-t-transparent bg-transparent px-3 py-2.5 font-sans text-sm font-normal text-blue-gray-700 outline outline-0 transition-all placeholder-shown:border placeholder-shown:border-blue-gray-200 placeholder-shown:border-t-blue-gray-200 focus:border-2 focus:border-cyan-700 focus:border-t-transparent focus:outline-0 disabled:border-0 disabled:bg-blue-gray-50"
              placeholder=" "
            />
            <label className="before:content[' '] after:content[' '] pointer-events-none absolute left-0 -top-1.5 flex h-full w-full select-none text-[11px] font-normal leading-tight text-blue-gray-400 transition-all before:pointer-events-none before:mt-[6.5px] before:mr-1 before:box-border before:block before:h-1.5 before:w-2.5 before:rounded-tl-md before:border-t before:border-l before:border-blue-gray-200 before:transition-all after:pointer-events-none after:mt-[6.5px] after:ml-1 after:box-border after:block after:h-1.5 after:w-2.5 after:flex-grow after:rounded-tr-md after:border-t after:border-r after:border-blue-gray-200 after:transition-all peer-placeholder-shown:text-sm peer-placeholder-shown:leading-[3.75] peer-placeholder-shown:text-blue-gray-500 peer-placeholder-shown:before:border-transparent peer-placeholder-shown:after:border-transparent peer-focus:text-[11px] peer-focus:leading-tight peer-focus:text-cyan-900 peer-focus:before:border-t-2 peer-focus:before:border-l-2 peer-focus:before:border-cyan-900 peer-focus:after:border-t-2 peer-focus:after:border-r-2 peer-focus:after:border-cyan-900 peer-disabled:text-transparent peer-disabled:before:border-transparent peer-disabled:after:border-transparent peer-disabled:peer-placeholder-shown:text-blue-gray-500">
              Postleitzahl
            </label>
          </div>

          <div className="mb-4">
            <div className="relative h-10 w-full min-w-[200px]">
              <input
                name="telefon"
                onChange={handleChange}
                value={formData.telefon}
                className="peer h-full w-full rounded-[7px] border border-blue-gray-200 border-t-transparent bg-transparent px-3 py-2.5 font-sans text-sm font-normal text-blue-gray-700 outline outline-0 transition-all placeholder-shown:border placeholder-shown:border-blue-gray-200 placeholder-shown:border-t-blue-gray-200 focus:border-2 focus:border-cyan-700 focus:border-t-transparent focus:outline-0 disabled:border-0 disabled:bg-blue-gray-50"
                placeholder=" "
                required
              />
              <label className="before:content[' '] after:content[' '] pointer-events-none absolute left-0 -top-1.5 flex h-full w-full select-none text-[11px] font-normal leading-tight text-blue-gray-400 transition-all before:pointer-events-none before:mt-[6.5px] before:mr-1 before:box-border before:block before:h-1.5 before:w-2.5 before:rounded-tl-md before:border-t before:border-l before:border-blue-gray-200 before:transition-all after:pointer-events-none after:mt-[6.5px] after:ml-1 after:box-border after:block after:h-1.5 after:w-2.5 after:flex-grow after:rounded-tr-md after:border-t after:border-r after:border-blue-gray-200 after:transition-all peer-placeholder-shown:text-sm peer-placeholder-shown:leading-[3.75] peer-placeholder-shown:text-blue-gray-500 peer-placeholder-shown:before:border-transparent peer-placeholder-shown:after:border-transparent peer-focus:text-[11px] peer-focus:leading-tight peer-focus:text-cyan-900 peer-focus:before:border-t-2 peer-focus:before:border-l-2 peer-focus:before:border-cyan-900 peer-focus:after:border-t-2 peer-focus:after:border-r-2 peer-focus:after:border-cyan-900 peer-disabled:text-transparent peer-disabled:before:border-transparent peer-disabled:after:border-transparent peer-disabled:peer-placeholder-shown:text-blue-gray-500">
                *Telefon
              </label>
            </div>
          </div>

          <div className="mb-4">
            <div className="relative h-10 w-full min-w-[200px]">
              <input
                name="email"
                onChange={handleChange}
                value={formData.email}
                className="peer h-full w-full rounded-[7px] border border-blue-gray-200 border-t-transparent bg-transparent px-3 py-2.5 font-sans text-sm font-normal text-blue-gray-700 outline outline-0 transition-all placeholder-shown:border placeholder-shown:border-blue-gray-200 placeholder-shown:border-t-blue-gray-200 focus:border-2 focus:border-cyan-700 focus:border-t-transparent focus:outline-0 disabled:border-0 disabled:bg-blue-gray-50"
                placeholder=" "
                required
              />
              <label className="before:content[' '] after:content[' '] pointer-events-none absolute left-0 -top-1.5 flex h-full w-full select-none text-[11px] font-normal leading-tight text-blue-gray-400 transition-all before:pointer-events-none before:mt-[6.5px] before:mr-1 before:box-border before:block before:h-1.5 before:w-2.5 before:rounded-tl-md before:border-t before:border-l before:border-blue-gray-200 before:transition-all after:pointer-events-none after:mt-[6.5px] after:ml-1 after:box-border after:block after:h-1.5 after:w-2.5 after:flex-grow after:rounded-tr-md after:border-t after:border-r after:border-blue-gray-200 after:transition-all peer-placeholder-shown:text-sm peer-placeholder-shown:leading-[3.75] peer-placeholder-shown:text-blue-gray-500 peer-placeholder-shown:before:border-transparent peer-placeholder-shown:after:border-transparent peer-focus:text-[11px] peer-focus:leading-tight peer-focus:text-cyan-900 peer-focus:before:border-t-2 peer-focus:before:border-l-2 peer-focus:before:border-cyan-900 peer-focus:after:border-t-2 peer-focus:after:border-r-2 peer-focus:after:border-cyan-900 peer-disabled:text-transparent peer-disabled:before:border-transparent peer-disabled:after:border-transparent peer-disabled:peer-placeholder-shown:text-blue-gray-500">
                *E-mail
              </label>
            </div>
          </div>

          <div className="mb-4">
            <div className="relative h-auto w-full min-w-[200px]">
              <textarea
                name="text"
                onChange={handleChange}
                value={formData.text}
                className="peer h-full w-full rounded-[7px] border border-blue-gray-200 border-t-transparent bg-transparent px-3 py-2.5 font-sans text-sm font-normal text-blue-gray-700 outline outline-0 transition-all placeholder-shown:border placeholder-shown:border-blue-gray-200 placeholder-shown:border-t-blue-gray-200 focus:border-2 focus:border-cyan-700 focus:border-t-transparent focus:outline-0 disabled:border-0 disabled:bg-blue-gray-50"
                placeholder=" "
                rows="2"
              />
              <label className="before:content[' '] after:content[' '] pointer-events-none absolute left-0 -top-1.5 flex h-full w-full select-none text-[11px] font-normal leading-tight text-blue-gray-400 transition-all before:pointer-events-none before:mt-[6.5px] before:mr-1 before:box-border before:block before:h-1.5 before:w-2.5 before:rounded-tl-md before:border-t before:border-l before:border-blue-gray-200 before:transition-all after:pointer-events-none after:mt-[6.5px] after:ml-1 after:box-border after:block after:h-1.5 after:w-2.5 after:flex-grow after:rounded-tr-md after:border-t after:border-r after:border-blue-gray-200 after:transition-all peer-placeholder-shown:text-sm peer-placeholder-shown:leading-[3.75] peer-placeholder-shown:text-blue-gray-500 peer-placeholder-shown:before:border-transparent peer-placeholder-shown:after:border-transparent peer-focus:text-[11px] peer-focus:leading-tight peer-focus:text-cyan-900 peer-focus:before:border-t-2 peer-focus:before:border-l-2 peer-focus:before:border-cyan-900 peer-focus:after:border-t-2 peer-focus:after:border-r-2 peer-focus:after:border-cyan-900 peer-disabled:text-transparent peer-disabled:before:border-transparent peer-disabled:after:border-transparent peer-disabled:peer-placeholder-shown:text-blue-gray-500">
                Beschreibung oder Hinweise
              </label>
            </div>
          </div>

          <div className="mb-4">
            <label className="block mb-2 text-sm font-medium text-gray-700">
              Woher kennen Sie uns?
            </label>

            <input
              type="text"
              name="woherkennen"
              value={formData.woherkennen}
              onChange={handleChange}
              placeholder="z.B. Instagram, Freunde, Google ..."
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:border-cyan-700"
            />
          </div>
          {/* <div className="mb-4 flex-col items-center mx-auto space-y-4">
            <label className="items-center text-sm font-medium text-gray-700">
              Woher kennen Sie uns?
            </label>
            <select
              value={selectedOption}
              onChange={handleOptionChange}
              className="w-full appearance-none bg-white border border-gray-300 hover:border-gray-500 px-4 py-2 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
            >
              {options.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
          </div> */}

          <div className="flex justify-between gap-4">
            <button
              onClick={() => {
                setFormData({
                  vorkenntnisse: false,
                  leseniveau: '',
                  muttersprache: '',
                  woherkennen: '',
                  nachname: '',
                  vorname: '',
                  vornameArabisch: '',
                  nachnameArabisch: '',
                  geburtsdatum: '',
                  plz: '',
                  telefon: '',
                  email: '',
                  text: '',
                });
              }}
              className="flex-1 px-6 py-3 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition-colors duration-300 font-semibold"
            >
              <span className="flex items-center justify-center gap-2">
                <span>🗑️</span>
                Formular löschen
              </span>
            </button>
            <button
              type="submit"
              className="flex-1 px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors duration-300 font-semibold"
            >
              <span className="flex items-center justify-center gap-2">
                <span>📨</span>
                Absenden
              </span>
            </button>
          </div>
        </form>
      </div>
      <AnnourFooter />
    </div>
  );
};

export default StudentRegForm;
